// extracted by mini-css-extract-plugin
export default {"caption":"caption_caption__tp1k3","captionRight":"caption_captionRight__1Xmt+","captionCenter":"caption_captionCenter__CWJRo","captionGreen":"caption_captionGreen__-eKBr"};